import { createContext, useContext } from 'react';

/**
 * `profession._id` → chip colour, from the site professions catalog with the
 * per-project override already resolved by the backend.
 * Built once at the top of the Tags page.
 */
const ProfessionColorContext = createContext<ReadonlyMap<string, string | null>>(new Map());

export const ProfessionColorProvider = ProfessionColorContext.Provider;

/** The `profession._id` → catalog colour map for the current Tags page. */
export function useProfessionColorMap(): ReadonlyMap<string, string | null> {
  return useContext(ProfessionColorContext);
}
